import { makeParams, makeRequestV2 } from "../api/makeRequest"
import { RequestMethods } from "../api/requestMethode"
import url from "../api/urls"

export class ClientServiceV2 {
    static async getOperatorStats(shiftId: any, type: any, pageNumber: number, pageSize: number, payload: any) {
        const params = makeParams([
            {
                index: "stat_type",
                value: type
            },
            {
                index: "pageNumber",
                value: pageNumber
            },
            {
                index: "pageSize",
                value: pageSize
            }
        ])
        return await makeRequestV2(url.v2.getOperatorStats + "/" + shiftId + params, RequestMethods.POST, payload)
    }

    static async getBiometricStats(shiftId: any, pageSize: number, pageNumber: number, payload: any) {
        const params = makeParams([
            {
                index: "pageSize",
                value: pageSize
            },
            {
                index: "pageNumber",
                value: pageNumber
            },
        ])
        return await makeRequestV2(url.v2.operatorStats + "/" + shiftId + params, RequestMethods.POST, payload)
    }

    static async getVerificationData(shiftId: any, pageNumber: any, pageSize: any, payload: any) {
        const params = makeParams([
            { index: 'pageNumber', value: pageNumber },
            { index: 'pageSize', value: pageSize },
            // {index:'searchText', value:searchText}
        ])
        return await makeRequestV2(url.v2.getVerificationData + "/" + shiftId + params, RequestMethods.POST, payload);
    }

    static async getAllCSRReport(shiftId: any, pageSize: number, pageNumber: number, centerId: any) {
        const params = makeParams([
            {
                index: "pageSize",
                value: pageSize
            },
            {
                index: "pageNumber",
                value: pageNumber
            },
            {
                index: "centerId",
                value: centerId
            },
        ])
        return await makeRequestV2(url.client.getAllCSRReport + "/" + shiftId + params, RequestMethods.GET)
    }
}   